import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-frame-snimei-detail-config',
  templateUrl: './frame-snimei-detail-config.component.html',
  styleUrls: ['./frame-snimei-detail-config.component.scss']
})
export class AtwFrameSnimeiDetailConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Output() changeOptionConfig = new EventEmitter<any>();
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  public optionsBackground = [
    {
      label: 'hinh_nen',
      value: 'image',
    },
    {
      label: 'mau_nen',
      value: 'color',
    },
  ];

  public borderWidth = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
  public borderRadius = 0; // Giá trị border-radius của frame
  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
  public loadComplete = false;
  public openMenu: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
  ];
  lookUp = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage,
    private matdialog: MatDialog,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      this.initData();
  }

  openHandler(value: string): void {
    for (const key in this.openMenu) {
      if (key !== value) {
        this.openMenu[key] = false;
      }
    }
  }

  /** Hàm này thực hiện khởi tạo dữ liệu;
   *
   */
  initData() {
    if (this.config && this.class) {
      this.loadComplete = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId))
      if (changes) {
        if (changes.data_config) {
          this.config = changes.data_config.currentValue;
          this.initData();
        }
        if (changes.device) this.device = changes.device.currentValue;
      }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }

  //Hàm update class
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }


  handleChangeContainer(event: any) {
    this.config['frame-product-detail__boundary']['is_container'] = event;
    if (event) {
      this.class['frame-product-detail__boundary']['width'] = '75%';
      this.class['frame-product-detail__boundary']['position'] = 'relative';
    } else {
      this.class['frame-product-detail__boundary']['width'] = '100%';
      this.class['frame-product-detail__boundary']['position'] = 'unset';
    }
    this.updateClass();
    this.updateConfig();
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-product-detail']['width'] = event.width + 'px';
    if (event.height) this.class['frame-product-detail']['min-height'] = event.height + 'px';
    this.updateClass()
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
  }

  /**
 * Cập nhật staticdata vào database.
 */
  updateStaticdata() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  }
}
